

   <div class="container">
      <table class="table is-striped is-narrow is-hoverable is-fullwidth">
         <thead>
            <tr>
               <th>date</th>
               <th>todo</th>
               <th>desc</th>
               <th>prio</th>
               <th>status</th>
            </tr>
         </thead>

         <tbody>
            <tr *ngFor="let todo of todos">
               <td>{{todo.date}}</td>
               <td>{{ todo.title }}</td>
               <td>{{ todo.description }}</td>
               <td>{{ todo.priority }}</td>
               <td>{{ todo.status }}</td>
            </tr>
         </tbody>
      </table>
   </div>

